/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Various data for marketing purposes.
 */
export interface Marketing {
  /**
   * Verti specific campaign code.
   */
  campaignCode?: string;
  /**
   * Verti specific code for tell-a-friend (TAF).
   */
  taf?: string;
}
